import { useTimeMarker } from '../../../hooks';
import { useTimelineStore } from '../../../store';
import { useCurrentTime } from './useCurrentTime';

type TimeMarkerTimeProps = {
  startDate: Date;
  endDate: Date;
};

export const TimeMarkerTime = ({ startDate, endDate }: TimeMarkerTimeProps) => {
  const currentFilter = useTimelineStore((state) => state.filters.current);
  const currentTime = useCurrentTime('H:mm');
  const { isTimeMarkerVisible, timeMarkerDistance } = useTimeMarker(startDate, endDate, currentFilter.measureScale);

  if (!isTimeMarkerVisible) {
    return null;
  }

  return (
    <div
      className="absolute -top-2 flex w-10 -translate-x-1/2 items-center justify-center rounded-full bg-surface-brand-darker px-2 py-0.5 shadow-tiny"
      style={{ left: timeMarkerDistance }}
    >
      <span className="text-s11-sb text-white">{currentTime}</span>
    </div>
  );
};
